import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { Icon } from 'components';
import globalMsgs from 'messages';
import { AsyncBetslipBetCount } from 'modules/betslip/async';
import { DEFAULT_SPACING } from 'styles/spacing';
import { getNumberValueFromPx } from 'utils';
import Sidebar from '../Sidebar';
import useSidebarToggler from './useSidebarToggler';

import arrowDownCircle from 'assets/svg/arrow-down-circle.svg';
import './sidebarToggler.scss';

const SidebarToggler: React.FC = () => {
    const {
        handleToggleSidebar,
        isSidebarOpen,
        isFullScreen,
        isAuthorized,
        isMedium,
        ignoreOffsetInTheaterMode,
    } = useSidebarToggler();
    const { formatMessage } = useIntl();

    if (isFullScreen && isMedium) return null;

    return (
        <div
            style={getDefaultBottomOffsetForTablet()}
            styleName={cn('container', {
                'is-full-screen': isFullScreen,
                'is-open-sidebar': isSidebarOpen,
                'is-offset-ignored-in-full-screen': ignoreOffsetInTheaterMode,
            })}
        >
            {!isFullScreen && (
                <div styleName="btn" onClick={handleToggleSidebar}>
                    {isSidebarOpen && formatMessage(globalMsgs.hide)}{' '}
                    {formatMessage(globalMsgs.bettingSlip)}
                    <AsyncBetslipBetCount />
                    <Icon glyph={arrowDownCircle} styleName="sidebar-icon" />
                </div>
            )}

            {(isSidebarOpen || isFullScreen) && (
                <Sidebar isAuthorized={isAuthorized} />
            )}
        </div>
    );
};

function getDefaultBottomOffsetForTablet(): object | undefined {
    const style = getComputedStyle(document.documentElement);
    const bottomOffset = getNumberValueFromPx(
        style.getPropertyValue('--bottom-offset')
    );

    // We should override "bottomOffset" for tablet resolution if it equals the default value,
    // because the integrator may not specify correct value for this case (only handles deskop/mobile)
    if (DEFAULT_SPACING.bottomOffset === bottomOffset) {
        return {
            '--bottom-offset': '0px',
        };
    }
}

export default React.memo(SidebarToggler);
